const fragment = `
fragment FacetFieldsLimited on SubFacet {
  id
  name
  isSelected
}
`;

export default fragment;
